import PropTypes from 'prop-types'
import React, { Component } from 'react'
import _ from 'lodash'
import { TutorialSummaryPropTypes as tutorialProptypes } from 'components/generic/CourseSummary/propTypes'
import LoadingComponent from 'components/generic/LoadingComponent'
import { tutorialsStatus } from 'reduxModules/tutorials'

import Tutorial from '../../../generic/CourseSummary'
import './styles.css'

export class TutorialListContent extends Component {
  render() {
    if (this.props.requestStatus !== tutorialsStatus.success)
      return <LoadingComponent />

    return (
      <section className="tutorials-list-content wrapper">
        {!_.isEmpty(this.props.specialVideos) && _.isEmpty(this.props.filters) && this.props.specialVideos.map((specialVideo, idx) => (
          <Tutorial
            key={specialVideo.id}
            className="tutorial"
            elementName={`special-video-${idx}`}
            slug={specialVideo.slug}
            summary={specialVideo.description}
            title={specialVideo.title}
            thumb={specialVideo.photo?.boxThumb || ''}
            isSpecial
          />
        ))}
        {!_.isEmpty(this.props.webinars) && _.isEmpty(this.props.filters) && this.props.webinars.map((webinar, idx) => (
          <Tutorial
            key={webinar.id}
            className="tutorial"
            elementName={`webinar-${idx}`}
            slug={webinar.slug}
            summary={webinar.tagline}
            teacher={webinar.artist?.title || ''}
            teacherSlug={webinar.artist?.slug || ''}
            title={webinar.title}
            thumb={webinar.listingPhoto?.boxThumb || ''}
            isWebinar
          />
        ))}
        {this.props.tutorials.map((tutorial, idx) => (
          <Tutorial
            key={`tutorial-${tutorial.id}`}
            className="tutorial"
            elementName={`tutorial-${idx}`}
            slug={tutorial.slug}
            summary={tutorial.description}
            teacher={tutorial.artist?.fullName || ''}
            teacherSlug={tutorial.artist?.slug || ''}
            title={tutorial.title}
            thumb={tutorial.photo?.boxThumb || ''}
            new={tutorial.new}
          />
        ))}
      </section>
    )
  }
}
TutorialListContent.propTypes = {
  tutorials: PropTypes.arrayOf(PropTypes.shape(tutorialProptypes)),
  requestStatus: PropTypes.string
}
export default TutorialListContent
